import React, { lazy } from 'react';

import { type Route, type Routes } from 'react-resource-router';

import { componentWithSuspense } from '../../utils';
import { AppAccessGate } from '../AppAccessGate';

const VisualiserHome = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_dtac-visualiser-home" */ '../../pages/visualiser/home'
		),
);

const VisualiserHomeWithAccess = (): JSX.Element => (
	<AppAccessGate appName="Visualiser">
		<VisualiserHome />
	</AppAccessGate>
);

const ROUTE_PREFIX = '/visualiser' as const;

const visualiserRoutesObject: Record<string, Route> = {
	home: {
		name: 'home',
		path: ROUTE_PREFIX,
		exact: true,
		component: componentWithSuspense(VisualiserHomeWithAccess),
	},
};

export const visualiserRoutes: Routes = Object.values(visualiserRoutesObject);
